import React, { Component } from 'react';
import { connect } from "react-redux";
import PromotionMiddleware from "../../store/prat_middleware/gt/promotionMiddleware";
import ProductMiddleware from "../../store/prat_middleware/gt/productMiddleware";
import CustomSelect from '../../components/common/select/Select';
import Button from "@material-ui/core/Button";
import DATA from '../../assets/data';
import ActivityPlanMiddleware from '../../store/prat_middleware/activityPlan/activityPlanMiddleware';
import ActivityPopUp from './activityPlanPopUp';
import './activityPlan.styles.scss';
import { Loader } from "../../components/loader/index";
import throttle from "lodash.throttle";
import {compare} from '../gt/validation/sort';
import CustomToast from '../../util-functions/customToast.jsx'

class ActivityPlan extends Component {

  constructor(props) {
    super(props);
    this.state = {
      division: "",
      category: "",
      selectedPromotionType: "",
      selectedPromotionLevel: "",
      selectedProductCategories: [],
      selectedProductSkus: [],
      selectedProductMasterSkus: [],
      selectedProductBrands: [],
      myBrands: [],
      mySkus: [],
      myMasterSkus: [],
      pageNo: 1,
      //   versions:[],
      data: [],
      selectedYear: '',
      selectedActivityStatus: [],
      popUp: false,
      popUpPositionY: '',
      popUpPositionX: '',
      promoData: null,
      promotionLevel: '',
      tablePromotionLevel: '',
      firstTimeDataLoad: true,
      totalData: '',
      receiveData: true,
      loading: true
    };
  };



  componentDidMount() {
    setTimeout(() => {
      this.props.get_productCategories();
      this.props.get_promotionLevel();
      this.props.get_AllPromotionType();
      this.props.get_productMasterSkus();
      this.props.get_productSkus();
      this.props.get_productBrands();
      // setTimeout(() => {
      //   this.getDataOnComponentMount();
      // }, 1000);
    }, 1000);
    this.page_wrapper.onscroll = (e) => {
      if (this.props.isActivityPlanLoading) return;
      const obj = e.target;
      const height = obj.scrollHeight - obj.offsetHeight;
      const scrollPos = obj.scrollTop;
      const factor = 0.9;
      if (scrollPos >= factor * height) {
        this.load_more();
      }
    };

  }
  
  componentDidUpdate(prevProps, prevState) {

    if (prevProps.product_categories !== this.props.product_categories) {
      this.getDataOnComponentMount();
    }
  }

  componentWillUnmount() {
    this.setState({
      data: [],
      receiveData: true
    })
  }

  load_more = throttle(this.load_Data, 800, {
    trailing: false,
  });

  load_Data() {
    if (this.state.data.length === this.state.totalData || this.props.activityPlanHasError) return;
    this.setState(
      {
        pageNo: this.state.pageNo + 1,
        receiveData: true
      },
      () => {
        this.props.getActivityPlan(
          this.state.pageNo,
          this.state.selectedPromotionLevel,
          this.state.selectedProductCategories,
          this.state.selectedProductBrands,
          this.state.selectedProductMasterSkus,
          this.state.selectedProductSkus,
          this.state.selectedYear,
          this.state.selectedActivityStatus,
          this.state.selectedPromotionType
        );
      }
    );
  }

  getDataOnComponentMount = () => {
    this.setState(
      {
        pageNo: 1,
        selectedPromotionLevel: '2913ccde-1826-410b-bce2-c52ab23106fb',
        selectedProductCategories: [this.props.product_categories.length ? this.props.product_categories[0].guid : []],
        selectedProductBrands: [],
        selectedProductMasterSkus: [],
        selectedProductSkus: [],
        selectedYear: new Date().getFullYear(),
        selectedActivityStatus: [],
        data: [],
        receiveData: true
      },
      () => {
        this.props.getActivityPlan(
          this.state.pageNo,
          this.state.selectedPromotionLevel,
          this.state.selectedProductCategories,
          this.state.selectedProductBrands,
          this.state.selectedProductMasterSkus,
          this.state.selectedProductSkus,
          this.state.selectedYear,
          this.state.selectedActivityStatus,
          this.state.selectedPromotionType
        );
      }
    );
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.activityPlan && nextProps.activityPlan.results && this.state.receiveData) {
      if (nextProps.activityPlan) {
        this.setState({
          totalData: nextProps.activityPlan.total_count,
          receiveData: false,
          loading: false
        })
        this.propsReceived(nextProps.activityPlan.results);
      }
    }
  }

  propsReceived = (value) => {
    if (value) {
      value.forEach(item => (this.state.data.push(item)))
    }
  }

  handleCategory = category => {
    let arr = [];
    if (category === null || category.length === 0) {
      this.setState({ selectedProductCategories: [], selectedProductBrands: [], selectedProductMasterSkus: [], selectedProductSkus: [], myBrands: [], myMasterSkus: [], mySkus: [] })
    }
    else {
      category.forEach(element => {
        arr.push(element.value);
      });
      this.setState({ selectedProductCategories: arr }, () => {
        this.handleFilteredBrands();
      });
    }
  };

  handleFilteredBrands = () => {
    const {
      selectedProductCategories,
      myBrands,
      selectedProductBrands
    } = this.state;
    const { product_brands } = this.props;
    let filteredbrands = [];
    if (selectedProductCategories.length) {
      for (let i = 0; i < selectedProductCategories.length; i++) {
        filteredbrands.push(
          ...product_brands.filter(item => {
            return item.Category === selectedProductCategories[i];
          })
        );
      }

      this.setState({
        myBrands: filteredbrands
      });
      let arr = [];
      if (selectedProductBrands.length !== 0) {
        myBrands.forEach(element => {
          selectedProductBrands.forEach((e, i) => {
            if (element.guid === e) {
              arr.push(e);
              this.setState({ selectedProductBrands: arr });
            }
          });
        });
      }
    }
  };

  handleBrandChange = selectedBrand => {
    let arr = [];
    if (selectedBrand === null || selectedBrand.length === 0) {
      this.setState({ selectedProductBrands: [], selectedProductMasterSkus: [], selectedProductSkus: [], myMasterSkus: [], mySkus: [] })
    }
    else {
      selectedBrand.forEach(e => {
        arr.push(e.value);
      });
      this.setState({ selectedProductBrands: arr }, () => {
        this.handleFilteredMasterSku();
      });
    }
  };

  handleFilteredMasterSku = () => {
    const {
      selectedProductBrands,
      selectedProductMasterSkus,
      myMasterSkus
    } = this.state;
    const { product_master_skus } = this.props;
    let filteredSkus = [];
    if (selectedProductBrands.length) {
      for (let i = 0; i < selectedProductBrands.length; i++) {
        filteredSkus.push(
          ...product_master_skus.filter(item => {
            return item.Brand === selectedProductBrands[i];
          })
        );
      }
      this.setState({
        myMasterSkus: filteredSkus
      });
      let selectedSkuFinal = [];
      if (selectedProductMasterSkus.length !== 0) {
        myMasterSkus.forEach(element => {
          selectedProductMasterSkus.forEach((e, i) => {
            if (element.guid === e) {
              selectedSkuFinal.push(e);
              this.setState({ selectedProductMasterSkus: selectedSkuFinal });
            }
          });
        });
      }
    }
  };

  handleMasterSkusChange = selectedMasterSku => {
    let arr = [];
    if (selectedMasterSku === null || selectedMasterSku.length === 0) {
      this.setState({ selectedProductMasterSkus: [], selectedProductSkus: [], mySkus: [] })
    }
    else {
      selectedMasterSku.forEach(e => {
        arr.push(e.value);
      });
      this.setState({ selectedProductMasterSkus: arr }, () => {
        this.handleFilteredSku();
      });
    }
  };

  handleFilteredSku() {
    const {
      selectedProductMasterSkus,
      selectedProductSkus,
      mySkus
    } = this.state;
    const { product_skus } = this.props;
    let filteredSkus = [];
    if (selectedProductMasterSkus.length) {
      for (let i = 0; i < selectedProductMasterSkus.length; i++) {
        filteredSkus.push(
          ...product_skus.filter(item => {
            return item.MasterSku === selectedProductMasterSkus[i];
          })
        );
      }
      this.setState({
        mySkus: filteredSkus
      });
      let selectedSkuFinal = [];
      if (selectedProductMasterSkus.length !== 0) {
        mySkus.forEach(element => {
          selectedProductSkus.forEach((e, i) => {
            if (element.guid === e) {
              selectedSkuFinal.push(e);
              this.setState({ selectedProductSkus: selectedSkuFinal });
            }
          });
        });
      }
    }
  };

  handleSkusChange = selectedSku => {
    let arr = [];
    if (selectedSku === null || selectedSku.length === 0) {
      this.setState({ selectedProductSkus: [] })
    }
    else {
      selectedSku.forEach(e => {
        arr.push(e.value);
      });
      this.setState({ selectedProductSkus: arr });
    }
  };

  handlePromotionLevel = level => {
    if (level) {
      this.setState({
        selectedProductCategories: [],
        selectedProductSkus: [],
        selectedProductMasterSkus: [],
        selectedProductBrands: [],
        myBrands: [],
        mySkus: [],
        myMasterSkus: [],
      })
      let name = this.props.promotion_level.filter(item => item.guid === level.value)
      this.setState({
        selectedPromotionLevel: level.value,
        promotionLevel: name[0].Label
      });
    }
  };

  handleStatusType = (status) => {
    if (status) {
      let arr = [];
      status.forEach(element => {
        arr.push(element.value);
      });
      this.setState({ selectedActivityStatus: arr });
    }
  };

  handleYearChange = (selectedValue) => {
    if (selectedValue) {
      this.setState({
        selectedYear: selectedValue.value,
      });
    }
  };

  handlePromotionType = selectedValue => {
    if (selectedValue) {
      this.setState({
        selectedPromotionType: selectedValue.value,
      });
    } else {
      this.setState({
        selectedPromotionType: "",
      });
    }
  };


  handleSubmit = () => {
    // When promotion level is category
    if (this.state.selectedPromotionLevel === '2913ccde-1826-410b-bce2-c52ab23106fb') {
      if (this.state.selectedProductCategories.length) {
        this.setState({
          data: [],
          tablePromotionLevel: this.state.promotionLevel,
          pageNo: 1,
          receiveData: true,
          loading: true
        },
          () => {
            this.props.getActivityPlan(
              this.state.pageNo,
              this.state.selectedPromotionLevel,
              this.state.selectedProductCategories,
              this.state.selectedProductBrands,
              this.state.selectedProductMasterSkus,
              this.state.selectedProductSkus,
              this.state.selectedYear,
              this.state.selectedActivityStatus,
              this.state.selectedPromotionType
            )
          })
      } else {
        // ToastsStore.error("Category is not selected!")
        CustomToast('error', 'Category is not selected!')
      }
    }
    // When promotion level is brand
    else if (this.state.selectedPromotionLevel === '6ff61eed-bc02-4dba-9381-7e6ebdd57006') {
      if (this.state.selectedProductCategories.length) {
        if (this.state.selectedProductBrands.length) {
          this.setState({
            data: [],
            tablePromotionLevel: this.state.promotionLevel,
            pageNo: 1,
            receiveData: true,
            loading: true
          },
            () => {
              this.props.getActivityPlan(
                this.state.pageNo,
                this.state.selectedPromotionLevel,
                this.state.selectedProductCategories,
                this.state.selectedProductBrands,
                this.state.selectedProductMasterSkus,
                this.state.selectedProductSkus,
                this.state.selectedYear,
                this.state.selectedActivityStatus,
                this.state.selectedPromotionType
              )
            })
        }
        else {
          // ToastsStore.error("Brand is not selected!")
        CustomToast('error', 'Brand is not selected!')
        }
      } else {
        // ToastsStore.error("Category is not selected!")
        CustomToast('error', 'Category is not selected!')
      }
    }
    // When promotion level is Master SKU
    else if (this.state.selectedPromotionLevel === '6d6a6019-5221-48c6-9519-97eb73c8f547') {
      if (this.state.selectedProductCategories.length) {
        if (this.state.selectedProductBrands.length) {
          if (this.state.selectedProductMasterSkus.length) {
            this.setState({
              data: [],
              tablePromotionLevel: this.state.promotionLevel,
              pageNo: 1,
              receiveData: true,
              loading: true
            },
              () => {
                this.props.getActivityPlan(
                  this.state.pageNo,
                  this.state.selectedPromotionLevel,
                  this.state.selectedProductCategories,
                  this.state.selectedProductBrands,
                  this.state.selectedProductMasterSkus,
                  this.state.selectedProductSkus,
                  this.state.selectedYear,
                  this.state.selectedActivityStatus,
                  this.state.selectedPromotionType
                )
              })
          }
          else {
            // ToastsStore.error("Master SKU is not selected!")
        CustomToast('error', 'Master SKU is not selected!')
          }
        }
        else {
          // ToastsStore.error("Brand is not selected!")
        CustomToast('error', 'Brand is not selected!')
        }
      } else {
        // ToastsStore.error("Category is not selected!")
        CustomToast('error', 'Category is not selected!')
      }
    }
    // When promotion level is SKU
    else if (this.state.selectedPromotionLevel === '3ec7fe41-716e-40f3-9757-1e75cf74746a') {
      if (this.state.selectedProductCategories.length) {
        if (this.state.selectedProductBrands.length) {
          if (this.state.selectedProductMasterSkus.length) {
            if (this.state.selectedProductSkus.length) {
              this.setState({
                data: [],
                tablePromotionLevel: this.state.promotionLevel,
                pageNo: 1,
                receiveData: true,
                loading: true
              },
                () => {
                  this.props.getActivityPlan(
                    this.state.pageNo,
                    this.state.selectedPromotionLevel,
                    this.state.selectedProductCategories,
                    this.state.selectedProductBrands,
                    this.state.selectedProductMasterSkus,
                    this.state.selectedProductSkus,
                    this.state.selectedYear,
                    this.state.selectedActivityStatus,
                    this.state.selectedPromotionType
                  )
                })
            } else {
              // ToastsStore.error("SKU is not selected!")
        CustomToast('error', 'SKU is not selected!')
            }
          }
          else {
            // ToastsStore.error("Master SKU is not selected!")
        CustomToast('error', 'Master SKU is not selected!')
          }
        }
        else {
          // ToastsStore.error("Brand is not selected!")
        CustomToast('error', 'Brand is not selected!')
        }
      } else {
        // ToastsStore.error("Category is not selected!")
        CustomToast('error', 'Category is not selected!')
      }
    }

  }

  handleActivityPopUp = (e, item) => {
    e.preventDefault()
    this.setState({
      popUp: !this.state.popUp,
      popUpPositionY: e.pageY,
      popUpPositionX: e.pageX,
      promoData: item
    })
  }

  handleActivityPopUpClose = e => {
    e.preventDefault()
    this.setState({
      popUp: false
    })
  }

  handleActivityOpen = (item) => {
    let user = JSON.parse(localStorage.getItem('myData'))
    let groupUser = user.user.groups[0]
    if (groupUser === 'ACOM') {
      if (item.Status === 'Draft' || item.Status === 'Sent Back By CDF' || item.Status === 'Sent Back By CDFM' || item.Status === 'Sent Back By CMD') {
        this.props.history.push(`/gtform/${item.guid}?activity_status=${item.Status}/${item.PromomtionType === 'MTFTS' ? 'mt' : 'gt'}`)
      } else {
        this.props.history.push(`/promotionapproval/${item.guid}?activity_status=${item.Status}&${item.ActivityCode}`)
      }
    }
    else {
      this.props.history.push(`/promotionapproval/${item.guid}?activity_status=${item.Status}&${item.ActivityCode}`)
    }
  }

  render() {
    const {
      myBrands,
      mySkus,
      myMasterSkus,
      selectedProductMasterSkus,
      selectedProductCategories,
      selectedProductBrands,
      selectedPromotionLevel,
      selectedProductSkus,
      popUp,
      selectedPromotionType
    } = this.state;
    const {
      promotion_level,
      product_categories,
      promotion_types
    } = this.props;
    return (
      <div className="page-container">

        <div className="heading-and-download-container">

          <span className='component-heading'>Activity Plan</span>

        </div>

        <div className="select-container">


          <div className='filters-container-only'>
            {(this.props.isActivityPlanLoading
              || (this.props.isCategoryLoading)) && this.state.loading
              ?
              <Loader flag={true} />
              : (
                <CustomSelect.MyCustomSelect
                  placeholder="Promotion Type"
                  className='select-box-promo-type select-box'
                  isClearable={true}
                  options={
                    promotion_types
                      ? promotion_types.map(item => ({
                        value: item.guid,
                        label: item.Label
                      }))
                      : []
                  }
                  value={promotion_types
                    ? promotion_types
                      .filter(item => {
                        return !selectedPromotionType
                          ? void 0
                          : item.guid === selectedPromotionType;
                      })
                      .map(item => {
                        return {
                          value: item.guid,
                          label: item.Label
                        };
                      })
                    : void 0
                  }
                  onChange={this.handlePromotionType}
                />
              )}
            <CustomSelect.MySelect
              placeholder={"Promo Level"}
              className="select-box"
              isDisabled={this.props.isPromotionLevelLoading}
              options={promotion_level
                ?
                promotion_level.map((item) => ({
                  value: item.guid,
                  label: item.Label,
                })) : null}
              onChange={this.handlePromotionLevel}
              value={promotion_level
                ? promotion_level
                  .filter(item => {       // eslint-disable-line
                    if (item.guid === selectedPromotionLevel) {
                      return item
                    }
                  })
                  .map(item => {
                    return {
                      value: item.guid,
                      label: item.Label
                    };
                  }) : void 0}
            />

            <CustomSelect.MyCustomSelect
              placeholder={"Category"}
              allowSelectAll={true}
              isMulti
              options={
                product_categories
                  ? !product_categories
                    ? void 0
                    : product_categories.sort(compare).map(item => ({
                      value: item.guid,
                      label: item.Name
                    }))
                  : []
              }
              onChange={this.handleCategory}
              value={
                product_categories
                  ? product_categories
                    .filter(item => {
                      return !selectedProductCategories
                        ? void 0
                        : selectedProductCategories.includes(item.guid);
                    })
                    .map(item => {
                      return {
                        value: item.guid,
                        label: item.Name
                      };
                    }) : void 0
              }
            />

            {(selectedPromotionLevel === '') ||
              (selectedPromotionLevel === '6ff61eed-bc02-4dba-9381-7e6ebdd57006') ||   //BRAND
              (selectedPromotionLevel === '3ec7fe41-716e-40f3-9757-1e75cf74746a') || //SKU
              (selectedPromotionLevel === '6d6a6019-5221-48c6-9519-97eb73c8f547') ?   //MASTER SKU
              <CustomSelect.MyCustomSelect
                placeholder={"Brand"}
                allowSelectAll={true}
                isMulti
                options={
                  myBrands
                    ? myBrands.sort(compare).map(item => ({
                      value: item.guid,
                      label: item.Name
                    }))
                    : void 0
                }
                onChange={this.handleBrandChange}
                value={
                  myBrands
                    ? myBrands
                      .filter(item => {
                        return selectedProductBrands.includes(item.guid);
                      })
                      .map(item => {
                        return {
                          value: item.guid,
                          label: item.Name
                        };
                      })
                    : null
                }
              />
              :
              null
            }

            {(selectedPromotionLevel === '') ||
              (selectedPromotionLevel === '3ec7fe41-716e-40f3-9757-1e75cf74746a') ||  //SKU
              (selectedPromotionLevel === '6d6a6019-5221-48c6-9519-97eb73c8f547') ?    //MASTER SKU
              <CustomSelect.MyCustomSelect
                placeholder={"Master SKU"}
                allowSelectAll={true}
                isMulti
                options={
                  myMasterSkus
                    ? myMasterSkus.sort(compare).map(item => ({
                      value: item.guid,
                      label: item.Description
                    }))
                    : void 0

                }
                onChange={this.handleMasterSkusChange}
                value={
                  myMasterSkus
                    ? myMasterSkus
                      .filter(item => {
                        return selectedProductMasterSkus.includes(item.guid);
                      })
                      .map(item => {
                        return {
                          value: item.guid,
                          label: item.Description
                        };
                      })
                    : null
                }
              />
              :
              null
            }

            {(selectedPromotionLevel === '') ||
              (selectedPromotionLevel === '3ec7fe41-716e-40f3-9757-1e75cf74746a') ?  //SKU
              <CustomSelect.MyCustomSelect
                placeholder={"SKU"}
                allowSelectAll={true}
                isMulti
                options={
                  mySkus
                    ? mySkus.sort(compare).map(item => ({
                      value: item.guid,
                      label: item.Description
                    }))
                    : void 0

                }
                onChange={this.handleSkusChange}
                value={
                  mySkus
                    ? mySkus
                      .filter(item => {
                        return selectedProductSkus.includes(item.guid);
                      })
                      .map(item => {
                        return {
                          value: item.guid,
                          label: item.Description
                        };
                      })
                    : null
                }
              />
              :
              null
            }

            <CustomSelect.MySelect
              placeholder={"Year"}
              className="select-box"
              options={DATA.YEARS.map((item) => ({
                value: item.value,
                label: item.label,
              }))}
              onChange={this.handleYearChange}
              value={this.state.selectedYear
                ? DATA.YEARS
                  .filter(item => {       // eslint-disable-line
                    if (item.value === this.state.selectedYear) {
                      return item
                    }
                  })
                  .map(item => {
                    return {
                      value: item.value,
                      label: item.label
                    };
                  }) : void 0}
            />

            <CustomSelect.MyCustomSelect
              placeholder={"Status"}
              allowSelectAll={true}
              options={
                DATA.ACTIVITY_STATUS
                  ? !DATA.ACTIVITY_STATUS
                    ? void 0
                    : DATA.ACTIVITY_STATUS.map(item => ({
                      value: item.value,
                      label: item.label
                    }))
                  : []
              }
              onChange={this.handleStatusType}
              value={
                DATA.ACTIVITY_STATUS
                  ? DATA.ACTIVITY_STATUS
                    .filter(item => {
                      return !this.state.selectedActivityStatus
                        ? void 0
                        : this.state.selectedActivityStatus.includes(item.value);
                    })
                    .map(item => {
                      return {
                        value: item.value,
                        label: item.label
                      };
                    }) : void 0
              }
            />

          </div>

          <Button
            style={{ marginBottom: '16px' }}
            variant="outlined"
            className="submit-btn"
            onClick={(e) => this.handleSubmit(e)}
          >
            SUBMIT
              </Button>
        </div>

        <div className='activity-plan-container'>

              {/* Activity Popup Component */}
          {popUp ?
            <ActivityPopUp popUpPositionY={this.state.popUpPositionY ? this.state.popUpPositionY : null}
              popUpPositionX={this.state.popUpPositionX ? this.state.popUpPositionX : null}
              data={this.state.promoData ? this.state.promoData : null} handleActivityPopUpClose={(e) => this.handleActivityPopUpClose(e)}
              history={this.props.history} popUP={this.state.popUp} />
            : null}

          <div className="activity-plan-label-container">

            <div className='activity-plan-label'>
              <span className='label-color' style={{ backgroundColor: '#ff5e00' }}></span>
              <span className='label-text'>Draft</span>
            </div>

            <div className='activity-plan-label'>
              <span className='label-color' style={{ backgroundColor: '#008450' }}></span>
              <span className='label-text'>Approved By CDF/Mgr FI/CMD</span>
            </div>

            <div className='activity-plan-label'>
              <span className='label-color' style={{ backgroundColor: '#efb700' }}></span>
              <span className='label-text'>Sent Back By CDF/Mgr FI/CMD</span>
            </div>

            <div className='activity-plan-label'>
              <span className='label-color' style={{ backgroundColor: '#b81d13' }}></span>
              <span className='label-text'>Rejected By CDF/Mgr FI/CMD</span>
            </div>

            <div className='activity-plan-label'>
              <span className='label-color' style={{ backgroundColor: '#007fff' }}></span>
              <span className='label-text'>Submitted By ACOM</span>
            </div>

          </div>

          <div className='activity-plan-table-container'
            ref={(c) => (this.page_wrapper = c)}
          >

            <table className='activity-plan-table'>
            <thead>
              <tr>
                <th style={{ width: '10vw' }} className='activity-plan-table-header'>{this.state.tablePromotionLevel ? this.state.tablePromotionLevel : 'CATEGORY'}</th>

                {DATA.data.map((item,ind) => (
                  <th className='activity-plan-table-header' key={ind}>{item.name ? item.name : 'NULL'}</th>
                ))}
              </tr>

              <tr><td style={{ color: 'transparent' }}>NULL</td></tr>
            </thead>
              <tbody>

                {this.state.data ?
                  this.state.data.map((item,ind) => (
                    <tr key={ind}>

                      <td style={{ border: '1px solid #dfe1e5' }}>{item.Product ? item.Product : "NULL"}</td>

                      {Object.entries(item.Promotions).map(([key, value],ind) => (
                        <React.Fragment key={ind}>
                          {value.length ? <td style={{ border: '1px solid #dfe1e5', height: '88px', width: '96px' }} >
                            <span className='activity-plan-promo-container '>
                              {value.map((singlePromo,ind) => (
                                <span key={ind} className='activity-plan-promo activity-plan-tooltip' style={singlePromo.Status === "Draft" ? { backgroundColor: '#FFEEE5', color: '#ff5e00' }
                                  : singlePromo.Status === "Submitted By Acom" ? { backgroundColor: '#E5F2FF', color: '#007fff' }
                                    : singlePromo.Status === "Approved By CDF" ? { backgroundColor: '#E5F2ED', color: '#008450' }
                                      : singlePromo.Status === "Rejected By CDF" ? { backgroundColor: '#F8E8E7', color: '#b81d13' }
                                        : singlePromo.Status === "Sent Back By CDF" ? { backgroundColor: '#FFF8E8', color: '#ffb822' }
                                          : singlePromo.Status === "Approved By CDFM" ? { backgroundColor: '#E5F2ED', color: '#008450' }
                                            : singlePromo.Status === "Rejected By CDFM" ? { backgroundColor: '#F8E8E7', color: '#b81d13' }
                                              : singlePromo.Status === "Sent Back By CDFM" ? { backgroundColor: '#FFF8E8', color: '#ffb822' }
                                                : singlePromo.Status === "Approved By CMD" ? { backgroundColor: '#E5F2ED', color: '#008450' }
                                                  : singlePromo.Status === "Rejected By CMD" ? { backgroundColor: '#F8E8E7', color: '#b81d13' }
                                                    : singlePromo.Status === "Sent Back By CMD" ? { backgroundColor: '#FFF8E8', color: '#ffb822' } : null}
                                  data-tooltip="the tooltip is longer than the element"

                                  onClick={(e) => this.handleActivityPopUp(e, singlePromo)}
                                >{singlePromo.PromomtionType} | {singlePromo.WeekStart}-{singlePromo.WeekEnd}
                                </span>
                              ))}</span></td>
                            :
                            <td style={{ border: '1px solid #dfe1e5', height: '88px', width: '96px' }}><span></span></td>
                          }
                        </React.Fragment>
                      ))}

                    </tr>
                  ))
                  :
                  null
                }

              </tbody>

            </table>

          </div>

        </div>
        {this.props.isActivityPlanLoading ? <div>Loading...</div> : null}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    promotion_types: state.PromotionReducer.promotionType,
    promotion_level: state.PromotionReducer.promotionLevel,
    isPromotionLevelLoading: state.PromotionReducer.isPromotionLevelLoading,
    // product reducer
    product_devisions: state.ProductReducer.productDevisions,
    product_categories: state.ProductReducer.productCategories,
    product_brands: state.ProductReducer.productBrands,
    product_skus: state.ProductReducer.productSkus,
    product_master_skus: state.ProductReducer.productMasterSkus,
    isCategoryLoading: state.ProductReducer.isCategoryLoading,
    activityPlan: state.ActivityPlanReducer.activityPlan,
    activityPlanHasError: state.ActivityPlanReducer.activityPlanHasError,
    isActivityPlanLoading: state.ActivityPlanReducer.isActivityPlanLoading

  };
};

const mapDispatchToProps = dispatch => {
  return {
    get_promotionLevel: () => {
      return dispatch(PromotionMiddleware.get_promotionLevel());
    },
    get_productCategories: () => {
      return dispatch(ProductMiddleware.get_categories());
    },
    get_productBrands: () => {
      return dispatch(ProductMiddleware.get_brands());
    },
    get_productSkus: () => {
      return dispatch(ProductMiddleware.get_skus());
    },
    get_productMasterSkus: () => {
      return dispatch(ProductMiddleware.get_master_skus());
    },
    getActivityPlan: (
      pageNo,
      selectedPromotionLevel,
      selectedProductCategories,
      selectedProductBrands,
      selectedProductMasterSkus,
      selectedProductSkus,
      selectedYear,
      selectedActivityStatus,
      selectedPromotionType
    ) => {
      return dispatch(ActivityPlanMiddleware.getActivityPlan(
        pageNo,
        selectedPromotionLevel,
        selectedProductCategories,
        selectedProductBrands,
        selectedProductMasterSkus,
        selectedProductSkus,
        selectedYear,
        selectedActivityStatus,
        selectedPromotionType
      ))
    },
    get_AllPromotionType: () => {
      return dispatch(PromotionMiddleware.get_AllPromotionType());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ActivityPlan);